import {header} from "./header";
import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {listingPagesList_template} from "../components/templates/listingPagesList_template";

declare var ko: any;
declare var page: any;

export class listing_pages extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected listingPagesListTemplate: listingPagesList_template;
    protected pagination: pagination_template;
    protected viewPageUrl;

    protected getModuleName(): string{

        return "listing_pages";
    }

    buildContent(): Array<Element>{

        // create the article list
        this.listingPagesListTemplate = new listingPagesList_template("list", this.viewModel, this);
        this.listingPagesListTemplate.setAddButtonShown(false);

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Hub Pages List");

        return [this.listingPagesListTemplate.build()];
    }

    public fillPage() : void{

        this.filterList();
    }


    public filterList(): void{

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.listingPagesListTemplate.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/config/listing-pages/get';
        let usrReq_params: Array<Array<string>> = [];

        usrReq_params.push(["data", ko.toJSON(this.listingPagesListTemplate.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onListFormDataRequestReturn;
        this.XHRHdl.execute();

    }

    protected onListFormDataRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let response = JSON.parse(req.request.response);
                obj.updateList(response);

                obj.loadingOut(obj.listingPagesListTemplate.builtTemplate.children.namedItem("list-results"));
            });

       }
    }

    protected add(){

        this.saveViewModule(this.getMemoryViewModel());

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/listing-pages/add');
    }


    protected paginationOnPageClick(){

        this.filterList();
    }


    protected listingPagesListReorder(): void {

        this.filterList();
    }

    protected filterSimpleOnChange(idElement){

        this.listingPagesListTemplate.setPageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }



    protected updateList(response: any): void {

        this.listingPagesListTemplate.setListingPages(response.data, this.getBrandId());

        let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
        this.listingPagesListTemplate.setResultInfo(response.totalCount, response.totalPage, execTime );

        //Update the Paginator
        // this.viewModel.list.pagination.itemCount(response.totalCount);
        this.listingPagesListTemplate.setItemCount(response.totalCount);
    }

    public viewOnWebsite(permalink: string) {

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let userBrands = this.getVnAppZone().app.loggedUser.user.brands;
        let url = window.location.hostname.split(".");
        let urlBegin = "https://";
        let isLocal = false;

        if ( url.length == 3 ) { // Not on live

            if ( url[0] != "emakicms") { // Either on qa, staging or ads
                urlBegin += url[0]+".";
            } else {
                isLocal = true;
            }
        }

        for (let i=0; i< userBrands.length; i++) {
            if (userBrands[i].id == idBrand) {

                window.open(urlBegin + userBrands[i].domain.replace("www.", "") + ( isLocal ? ( "." +url[2] ) : "" ) + permalink, "_blank")
                break;
            }
        }
    }

    protected getMemoryViewModel(){

        let templateViewModel = this.listingPagesListTemplate.getTemplateViewModel();

        delete templateViewModel.listingPages;

        return templateViewModel;
    }

    public edit(id: number): void {

        this.saveViewModule(this.getMemoryViewModel());
        let url = '/brand/' + this.getVnAppZone().app.params.idBrand + '/listing-pages/edit/';

        if (id != 0) {
            url += id;
        }

        page(url);
    }

    protected viewListingPage(id) {

        this.saveViewModule(this.getMemoryViewModel());

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/listing-pages/view/' + id + '/');
    }



    public delete(id: number): void {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.listingPagesListTemplate.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/config/listing-pages/delete/' + id + '/';
        let usrReq_params: Array<Array<string>> = [];

        // usrReq_params.push(["data", ko.toJSON(this.listingPagesListTemplate.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onDeleteListingPageReturn;
        this.XHRHdl.execute();

    }

    protected onDeleteListingPageReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let response = JSON.parse(req.request.response);
                obj.filterList();

                obj.loadingOut(obj.listingPagesListTemplate.builtTemplate.children.namedItem("list-results"));
            });


            obj.loadingOut(obj.listingPagesListTemplate.builtTemplate.children.namedItem("list-results"));
        }
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

}


// WEBPACK FOOTER //
// ./js/modules/listing_pages.ts